module.exports = __webpack_public_path__ + "images/pages/kaitori_bonus_lp/mainvisual-bg-sp_ad5dee4f63265b6aa16e94a2d640f643.svg";